<template>
  <div class="home">
    <!-- top   -->
    <div style="position:relative;">
      <img  class="bgroundImg" style="pointer-events: none;" src="~@/assets/img/bground.png"> 
      <!-- <img  class="bannerImg"  :src="require('@/assets/img/Fig2.png')" @click="flagImg = '1'"> -->
      <div class="bannerTitleImg">
        <el-row>
          <el-col :span="12"><img  class="titleImg"
            :src="flag === 'first'?require('@/assets/img/MODE0-on.png'):require('@/assets/img/MODE0-off.png')"
            @click="flag = 'first',activeName = 1">
          </el-col>
          <el-col :span="12"><img  class="titleImg"
            :src="flag === 'second'?require('@/assets/img/MODE1-on.png'):require('@/assets/img/MODE1-off.png')"
            @click="flag = 'second',activeName = 1">
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12"><img  class="titleImg"
            :src="flag === 'third'?require('@/assets/img/MODE2-on.png'):require('@/assets/img/MODE2-off.png')"
            @click="flag = 'third',activeName = 1">
          </el-col>
          <el-col :span="12"><img  class="titleImg"
            :src="flag === 'fourth'?require('@/assets/img/MODE3-on.png'):require('@/assets/img/MODE3-off.png')"
            @click="flag = 'fourth',activeName = 1">
          </el-col>
       </el-row>
      </div>
    </div>
    <div v-if="flag === 'first'">
      <img class="bannerCenter"  src="~@/assets/img/Mode0.png">
    </div>
    <div v-if="flag === 'second'">
      <img class="bannerCenter"  src="~@/assets/img/Mode1.png">
    </div>
    <div v-if="flag === 'third'">
      <img class="bannerCenter"  src="~@/assets/img/Mode2.png">
    </div>
    <div v-if="flag ==='fourth'">
      <img class="bannerCenter"  src="~@/assets/img/Mode3.png">
    </div>
    <div style="background-color: whitesmoke; width: 95%; margin-left: 2.5%; text-align: center;">
      <el-row :style="{height:rowHeight}">
        <el-col :span="6" :style="activeName === 1 ?'border-top: 2px solid #2a66ea;color: #2a66ea;font-weight: bold;':'border-top: 1px solid #e9e8f5;'">
          <div style="margin-top: 6%;" @click="activeName = 1">模式配置</div><i v-show="activeName === 1" class="el-icon-caret-bottom" style="color: blue;"></i></el-col>
        <el-col :span="6" :style="activeName === 2?'border-top: 2px solid #2a66ea;color: #2a66ea;font-weight: bold;':'border-top: 1px solid #e9e8f5;'">
          <div style="margin-top: 6%;" @click="activeName = 2">演示</div><i v-show="activeName === 2" class="el-icon-caret-bottom" style="color: blue;"></i></el-col>
        <el-col :span="6" :style="activeName === 3 ?'border-top: 2px solid #2a66ea;color: #2a66ea;font-weight: bold;':'border-top: 1px solid #e9e8f5;'">
          <div style="margin-top: 6%;" @click="activeName = 3">电路图</div><i v-show="activeName === 3" class="el-icon-caret-bottom" style="color: blue;"></i></el-col>
        <el-col :span="6" :style="activeName === 4?'border-top: 2px solid #2a66ea;color: #2a66ea;font-weight: bold;':'border-top: 1px solid #e9e8f5;'">
          <div style="margin-top: 6%;" @click="activeName = 4">资料下载</div><i v-show="activeName === 4" class="el-icon-caret-bottom" style="color: blue;"></i></el-col>
      </el-row>
    </div>
    <div v-show="flag === 'first'"  style="margin-top: 1%;">
      <v-touch @swipeleft="left" @swiperight="right" :swipe-options="{direction: 'horizontal'}">
      <el-card class="box-card" v-show="activeName === 1" style="width: 94.5%;margin-left: 2.5%;">
        <div>
          (左上角模式配置不操作)
        </div>
        <div>
          接线图如下：
        </div>
        <viewer>
          <img src="~@/assets/img/T11.jpg" style="width: 100%;">
        </viewer>
        <div>
          功能引脚提供UART0和UART1串口信号。
        </div>
      </el-card>
      <el-card class="box-card" v-show="activeName === 2" style="width: 94.5%;margin-left: 2.5%;">
        <div>
          1、安装串口驱动“CH343SER.EXE”。
        </div>
        <div style="text-align: justify;">
          2、打开CH347应用软件切换至“Uart Debug”或通用串口调试工具：
        </div>
        <viewer>
          <img :src="require('@/assets/img/Mode0-show-1.png')" style="width: 100%;">
        </viewer>
          3、串口通讯界面：
        <viewer>
          <img :src="require('@/assets/img/Mode0-show-2.png')" style="width: 100%;">
        </viewer>
      </el-card>
      <viewer>
        <img v-show="activeName === 3" :src="require('@/assets/img/Circuit.png')" style="width: 96%;margin-left: 2%;">
      </viewer>
      <el-card class="box-card" v-show="activeName === 4" style="width: 94.5%;margin-left: 2.5%;">
        <div class="text item">
          进入官网：<a href="https://wch.cn" style="color: blue;">https://wch.cn</a>
        </div>
        <div class="text item" style="text-align: justify;">
          依次点击：产品中心{{'\xa0'}}<img src="~@/assets/img/Arrow.png" style="width: 4%;">{{'\xa0'}}USB{{'\xa0'}}<img src="~@/assets/img/Arrow.png" style="width: 4%;">{{'\xa0'}}USB转串口类{{'\xa0'}}<img src="~@/assets/img/Arrow.png" style="width: 4%;">{{'\xa0'}}CH347
        </div>
        <viewer>
          <img :src="require('@/assets/img/Download-1.png')" style="width: 100%;">
          <img :src="require('@/assets/img/Download-2.png')" style="width: 100%;">
        </viewer>
      </el-card>
      </v-touch>
    </div>
    <div v-show="flag === 'second'" style="margin-top: 1%;">
      <v-touch @swipeleft="left" @swiperight="right" :swipe-options="{direction: 'horizontal'}"><!-- class="v-touch" style="touch-action: pan-y!important;" -->
      <el-card class="box-card" v-show="activeName === 1" style="width: 94.5%;margin-left: 2.5%;">
        <div>
          (左上角模式配置处CFG0与GND连接)
        </div>
        <div>
          1、操作串口、SPI、IIC接口，接线图如下：
        </div>
        <viewer>
          <img src="~@/assets/img/T21.jpg" style="width: 100%;">
        </viewer>
          2、操作串口、板载EEPROM、FLASH，接线图如下：
        <viewer>
          <img src="~@/assets/img/T22.jpg" style="width: 100%;">
        </viewer>
        <div>
          提供UART1串口信号+SPI+IIC接口信号。
        </div>
      </el-card>
      <el-card class="box-card" v-show="activeName === 2" style="width: 94.5%;margin-left: 2.5%;">
        <div style="text-align: justify;">
          1、安装CH347的USB转IIC、SPI、JTAG和GPIO等接口驱动“CH341PAR.EXE”。
        </div>
        <div style="text-align: justify;">
          2、打开CH347应用软件切换至“SPI/I2C/GPIO Debug”：
        </div>
        <viewer>
          <img :src="require('@/assets/img/Mode1-show-1.png')" style="width: 100%;">
        </viewer>
        <div style="text-align: justify;">
          3、设定SPI参数后点击“初始化SPI（C0）”，此页面可操作SPI、I2C、GPIO等接口，切换至“Uart Debug”界面使用UART接口：
        </div>
        <viewer>
          <img :src="require('@/assets/img/Mode1-show-2.png')" style="width: 100%;">
        </viewer>
      </el-card>
      <viewer>
        <img v-show="activeName === 3" :src="require('@/assets/img/Circuit.png')" style="width: 96%;margin-left: 2%;">
      </viewer>
      <el-card class="box-card" v-show="activeName === 4" style="width: 94.5%;margin-left: 2.5%;">
        <div class="text item">
          进入官网：<a href="https://wch.cn" style="color: blue;">https://wch.cn</a>
        </div>
        <div class="text item" style="text-align: justify;">
          依次点击：产品中心{{'\xa0'}}<img src="~@/assets/img/Arrow.png" style="width: 4%;">{{'\xa0'}}USB{{'\xa0'}}<img src="~@/assets/img/Arrow.png" style="width: 4%;">{{'\xa0'}}USB转串口类{{'\xa0'}}<img src="~@/assets/img/Arrow.png" style="width: 4%;">{{'\xa0'}}CH347
        </div>
        <viewer>
          <img :src="require('@/assets/img/Download-1.png')" style="width: 100%;">
          <img :src="require('@/assets/img/Download-2.png')" style="width: 100%;">
        </viewer>
        </el-card>
      </v-touch>
    </div>
    <div v-show="flag === 'third'"  style="margin-top: 1%;">
      <v-touch @swipeleft="left" @swiperight="right" :swipe-options="{direction: 'horizontal'}">
      <el-card class="box-card" v-show="activeName === 1" style="width: 94.5%;margin-left: 2.5%;">
        <div>
          (左上角模式配置处CFG1与GND连接)
        </div>
        <div>
          1、操作串口、SPI、IIC接口，接线图如下：
        </div>
        <viewer>
          <img src="~@/assets/img/T31.jpg" style="width: 100%;">
        </viewer>
          2、操作串口、板载EEPROM、FLASH，接线图如下：
        <viewer>
          <img src="~@/assets/img/T32.jpg" style="width: 100%;">
        </viewer>
        <div>
          提供UART1串口信号+SPI+IIC接口信号。
        </div>
      </el-card>
      <el-card class="box-card" v-show="activeName === 2" style="width: 94.5%;margin-left: 2.5%;">
        <div>
          1、此模式下无需安装驱动。
        </div>
        <div style="text-align: justify;">
          2、打开CH347应用软件切换至“SPI/I2C/GPIO Debug”：
        </div>
        <viewer>
          <img :src="require('@/assets/img/Mode2-show-1.png')" style="width: 100%;">
        </viewer>
        <div style="text-align: justify;">
          3、设定SPI参数后点击“初始化SPI（C0）”，此页面可操作SPI、I2C、GPIO等接口，切换至“Uart Debug”界面使用UART接口：
        </div>
        <viewer>
          <img :src="require('@/assets/img/Mode2-show-2.png')" style="width: 100%;">
        </viewer>
      </el-card>
      <viewer>
        <img v-show="activeName === 3" :src="require('@/assets/img/Circuit.png')" style="width: 96%;margin-left: 2%;">
      </viewer>
      <el-card class="box-card" v-show="activeName === 4" style="width: 94.5%;margin-left: 2.5%;">
        <div class="text item">
          进入官网：<a href="https://wch.cn" style="color: blue;">https://wch.cn</a>
        </div>
        <div class="text item" style="text-align: justify;">
          依次点击：产品中心{{'\xa0'}}<img src="~@/assets/img/Arrow.png" style="width: 4%;">{{'\xa0'}}USB{{'\xa0'}}<img src="~@/assets/img/Arrow.png" style="width: 4%;">{{'\xa0'}}USB转串口类{{'\xa0'}}<img src="~@/assets/img/Arrow.png" style="width: 4%;">{{'\xa0'}}CH347
        </div>
        <viewer>
          <img :src="require('@/assets/img/Download-1.png')" style="width: 100%;">
          <img :src="require('@/assets/img/Download-2.png')" style="width: 100%;">
        </viewer>
        </el-card>
      </v-touch>
    </div>
    <div v-show="flag === 'fourth'" style="margin-top: 1%;">
      <v-touch @swipeleft="left" @swiperight="right" :swipe-options="{direction: 'horizontal'}">
      <el-card class="box-card" v-show="activeName === 1" style="width: 94.5%;margin-left: 2.5%;">
        <div>
          (左上角CFG0和CFG1分别与GND连接)
        </div>
        <div>
          接线图如下所示：
        </div>
        <viewer>
          <img src="~@/assets/img/T41.jpg" style="width: 100%;">
        </viewer>
        <div>
          提供UART1串口信号+JTAG接口信号。
        </div>
      </el-card>
      <el-card class="box-card" v-show="activeName === 2" style="width: 94.5%;margin-left: 2.5%;">
        <div style="text-align: justify;">
          1、安装CH347的USB转IIC、SPI、JTAG和GPIO等接口驱动“CH341PAR.EXE”。
        </div>
        <div>
          2、打开CH347应用软件切换至“Jtag Debug”：
        </div>
        <viewer>
          <img :src="require('@/assets/img/Mode3-show-1.png')" style="width: 100%;">
        </viewer>
        <div style="text-align: justify;">
          3、设定JTAG TCK速率参数后点击“JtagConfig (D0)”，此页面可操作JTAG接口，切换至“Uart Debug”界面使用UART接口：
        </div>
        <viewer>
          <img :src="require('@/assets/img/Mode3-show-2.png')" style="width: 100%;">
        </viewer>
      </el-card>
      <viewer>
        <img v-show="activeName === 3" :src="require('@/assets/img/Circuit.png')" style="width: 96%;margin-left: 2%;">
      </viewer>
      <el-card class="box-card" v-show="activeName === 4" style="width: 94.5%;margin-left: 2.5%;">
        <div class="text item">
          进入官网：<a href="https://wch.cn" style="color: blue;">https://wch.cn</a>
        </div>
        <div class="text item" style="text-align: justify;">
          依次点击：产品中心{{'\xa0'}}<img src="~@/assets/img/Arrow.png" style="width: 4%;">{{'\xa0'}}USB{{'\xa0'}}<img src="~@/assets/img/Arrow.png" style="width: 4%;">{{'\xa0'}}USB转串口类{{'\xa0'}}<img src="~@/assets/img/Arrow.png" style="width: 4%;">{{'\xa0'}}CH347
        </div>
        <viewer>
          <img :src="require('@/assets/img/Download-1.png')" style="width: 100%;">
          <img :src="require('@/assets/img/Download-2.png')" style="width: 100%;">
        </viewer>
        </el-card>
      </v-touch>
    </div>
  </div>
</template>

<script>

export default {
  name: 'home',
  data() {
    return {
      activeName: 1,
      flag:'first',
      flagImg:'1',
      windowWidth:document.documentElement.clientWidth,
      rowHeight:  (document.documentElement.clientWidth)/10-2+'px',   //实时屏幕高度
    }
  },
  watch: {
      windowWidth (val) {
        this.rowHeight = (val)/10-2 + 'px'
      } 
  },
  mounted() {
    var that = this;
    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth;
        that.windowWidth = window.fullWidth; // 宽
      })()
    };
  },
  methods: {
    left(){
      if(this.activeName == 4){
        this.activeName = 1
        return;
      }
      if(this.activeName != 4){
        this.activeName = this.activeName + 1
      }
    },
    right(){
      if(this.activeName == 1){
        this.activeName = 4
        return;
      }
      if(this.activeName != 1){
        this.activeName = this.activeName - 1
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.home{
  font-size: 15px;
  width: 100%;
}

/* 头部 */
.bgroundImg{
   width:100%;
}
.bannerImg{
   width:370px;
   height: 112%;
   position: absolute;
   left: 50%;
   top: 75px;
   transform: translateX(-50%);
}
.bannerTitleImg{
  width:330px;
  position: absolute;
  left: 50%;
  top: 95px;
  transform: translateX(-49.5%);
}
.bannerCenter{
  width:60px;
  position: absolute;
  left: 50%;
  top: 138px;
  transform: translateX(-50%);
}
// 标题
.titleImg{
  width: 98%;
}




</style>


// WEBPACK FOOTER //
// src/view/index.vue